import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAthleteSummary } from "store/actions/resetAthleteSummaryAction";
import defaultImg from "../../assets/img/custom/bgImg.jpg";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import {
  acceptAthleteSummary,
  rejectAthleteSummary,
} from "store/actions/resetAthleteSummaryAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const ResetAthleteSummary = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const [visibleAthletes, setVisibleAthletes] = useState(5);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const athleteSummaryInfoPoints = [
    " The Admin receives a reset request from the athlete to clear their chat summary.",
    "After receiving the request, the Admin has the option to: accept, or reject the request.",
    "If the Admin accepts the request: the athlete’s chat summary is reset.",
  ];

  const athleteSummaryInfoTitle = "Reset Athlete Summary Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(
      getAthleteSummary(() => {
        setLoading(false);
      })
    );
  }, []);

  let { athleteSummary } = useSelector((state) => state.resetSummary);

  const toggleModal = () => {
    setConfirmModalOpen(!confirmModalOpen);
  };

  const openAcceptConfirmation = (athlete) => {
    setSelectedAthlete(athlete);
    setConfirmAction("accept");
    setConfirmModalOpen(true);
  };

  const openRejectConfirmation = (athlete) => {
    setSelectedAthlete(athlete);
    setConfirmAction("reject");
    setConfirmModalOpen(true);
  };

  const handleConfirmAction = async () => {
    if (!selectedAthlete) return;

    confirmAction === "accept"
      ? setConfirmLoading(true)
      : setRejectLoading(true);

    try {
      await dispatch(
        confirmAction === "accept"
          ? acceptAthleteSummary({
              id: selectedAthlete.id,
              name: `${selectedAthlete.first_name} ${selectedAthlete.last_name}`,
            })
          : rejectAthleteSummary(selectedAthlete.id)
      );
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmLoading(false);
      setRejectLoading(false);
      setConfirmModalOpen(false);
    }
  };

  const loadMoreRequests = () => {
    setLoadMoreLoading(true);
    setTimeout(() => {
      setVisibleAthletes((prev) => prev + 5);
      setLoadMoreLoading(false);
    }, 500);
  };

  const columns = ["", "Chat ID", "Email", "Rating"];

  const keyMap = {
    "": "profileImage",
    "Chat ID": "athleteID",
    Email: "email",
    Rating: "ratingText",
  };

  const preparedData = athleteSummary.map((data) => ({
    ...data,
    profileImage: (
      <img
        className="chat-profile"
        src={data?.player_image ? data.player_image.url : defaultImg}
        alt="Athlete profile"
      />
    ),
    ratingText: `Athlete ${data?.first_name} ${data?.last_name} has received ${
      data.count?.satisfied || 0
    } S, ${data.count?.NS || 0} U-NS and ${data.count?.RST || 0} U-RST out of ${
      data.totalChat || 0
    } total chats`,
  }));

  const renderActions = (row) => {
    return (
      <>
        <Button
          color="primary"
          size="sm"
          onClick={() => openAcceptConfirmation(row)}
        >
          Accept
        </Button>
        <Button
          color="danger"
          size="sm"
          onClick={() => openRejectConfirmation(row)}
        >
          Reject
        </Button>
      </>
    );
  };

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          {" "}
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Card className="p-2">
          {loading ? (
            <div className="text-center my-4">
              <Spinner size="lg" color="primary" />
            </div>
          ) : (
            <>
              <TableComponent
                columns={columns}
                data={preparedData.slice(0, visibleAthletes)}
                keyMap={keyMap}
                renderActions={renderActions}
              />
              {athleteSummary?.length > visibleAthletes && (
                <div className="text-center py-4">
                  <Button
                    onClick={loadMoreRequests}
                    color="primary"
                    disabled={loadMoreLoading}
                  >
                    {loadMoreLoading ? <Spinner size="sm" /> : "Load More"}
                  </Button>
                </div>
              )}
            </>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={athleteSummaryInfoPoints}
        title={athleteSummaryInfoTitle}
      />
      <Modal isOpen={confirmModalOpen} centered toggle={toggleModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              {selectedAthlete
                ? confirmAction === "accept"
                  ? `Are you sure you want to accept the summary for ${selectedAthlete.first_name} ${selectedAthlete.last_name}?`
                  : `Are you sure you want to reject the summary for ${selectedAthlete.first_name} ${selectedAthlete.last_name}?`
                : "Are you sure you want to proceed?"}
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={handleConfirmAction}>
              {confirmLoading ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={toggleModal}>
              {rejectLoading ? <Spinner size="sm" /> : "No"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ResetAthleteSummary;
